/**
 * @fileoverview gRPC-Web generated client stub for tprmquestionnaire
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: tprmquestionnaire/tprmquestionnaire.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.tprmquestionnaire = require('./tprmquestionnaire_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listQuestionnaireTemplates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listQuestionnaireTemplates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetQuestionnaireFormRequest,
 *   !proto.tprmquestionnaire.QuestionnaireForm>}
 */
const methodDescriptor_QuestionnaireService_GetQuestionnaireForm = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetQuestionnaireFormRequest,
  proto.tprmquestionnaire.QuestionnaireForm,
  /**
   * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireForm.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getQuestionnaireForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireForm>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getQuestionnaireForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ExportFormCsvRequest,
 *   !proto.tprmquestionnaire.ExportFormCsvResponse>}
 */
const methodDescriptor_QuestionnaireService_ExportFormCsv = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ExportFormCsvRequest,
  proto.tprmquestionnaire.ExportFormCsvResponse,
  /**
   * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ExportFormCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ExportFormCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.exportFormCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ExportFormCsvResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.exportFormCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ImportFormCsvRequest,
 *   !proto.tprmquestionnaire.ImportFormCsvResponse>}
 */
const methodDescriptor_QuestionnaireService_ImportFormCsv = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ImportFormCsvRequest,
  proto.tprmquestionnaire.ImportFormCsvResponse,
  /**
   * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ImportFormCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ImportFormCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.importFormCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ImportFormCsv,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ImportFormCsvResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.importFormCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ImportFormCsv);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.AddVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.AddVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_AddVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.AddVendorQuestionnaireRequest,
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.AddVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.AddVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.AddVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.addVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AddVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.AddVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.addVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AddVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AddVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SendVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.SendVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_SendVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SendVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SendVendorQuestionnaireRequest,
  proto.tprmquestionnaire.SendVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.SendVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SendVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SendVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SendVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SendVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.sendVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SendVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SendVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SendVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SendVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.sendVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SendVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SendVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyRequest,
 *   !proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse>}
 */
const methodDescriptor_QuestionnaireService_AnswerVendorQuestionnaireInternally = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/AnswerVendorQuestionnaireInternally',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyRequest,
  proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse,
  /**
   * @param {!proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.answerVendorQuestionnaireInternally =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AnswerVendorQuestionnaireInternally',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AnswerVendorQuestionnaireInternally,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.AnswerVendorQuestionnaireInternallyResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.answerVendorQuestionnaireInternally =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/AnswerVendorQuestionnaireInternally',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_AnswerVendorQuestionnaireInternally);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest,
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.updateVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UpdateVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.UpdateVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.updateVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/UpdateVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_UpdateVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest,
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.removeVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.RemoveVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.RemoveVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.removeVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/RemoveVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_RemoveVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListVendorQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnairesRequest,
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListVendorQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListVendorQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListVendorQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListVendorQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_GetVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetVendorQuestionnaireRequest,
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listReceivedQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listReceivedQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest,
 *   !proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>}
 */
const methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest,
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listVendorQuestionnaireVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListVendorQuestionnaireVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listVendorQuestionnaireVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListVendorQuestionnaireVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>}
 */
const methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getVendorQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetVendorQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getVendorQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetVendorQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 */
const methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.CreateCommentRequest,
 *   !proto.tprmquestionnaire.Comment>}
 */
const methodDescriptor_QuestionnaireService_CreateComment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/CreateComment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.CreateCommentRequest,
  proto.tprmquestionnaire.Comment,
  /**
   * @param {!proto.tprmquestionnaire.CreateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.Comment.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.Comment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.Comment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.createComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.Comment>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.createComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListCommentThreadRequest,
 *   !proto.tprmquestionnaire.ListCommentThreadResponse>}
 */
const methodDescriptor_QuestionnaireService_ListCommentThread = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListCommentThreadRequest,
  proto.tprmquestionnaire.ListCommentThreadResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListCommentThreadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListCommentThreadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listCommentThread =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListCommentThreadResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listCommentThread =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread);
};


module.exports = proto.tprmquestionnaire;

